import { Button, Dropdown, Menu, MenuProps, Tooltip } from "antd";
import asideLogo from "../../assets/images/AOC_LOGOTIP HORITZ-2.png";
import { HomeOutlined, QuestionOutlined, SettingOutlined, LogoutOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";

import styles from "./Aside.module.css";

import { useAuthContext } from "../../providers";
import { MouseEventHandler } from "react";

const helpItems: MenuProps["items"] = [
  {
    key: "1",
    label: <a href="mailto:support@omnios.ai">Contacta amb el suport</a>,
  },
  {
    type: "divider",
  },
  {
    key: "2",
    label: (
      <a
        className={styles.omniosLink}
        href="https://omnios.ai/"
        target="_blank"
        rel="noreferrer"
      >
        © {new Date().getFullYear()} • Omnios
      </a>
    ),
  },
];

const menuItems: MenuProps["items"] = [
  {
    key: "1",
    label: "Inici",
    icon: <HomeOutlined />,
  },
  {
    key: "2",
    label: "Llista blanca",
    icon: <SettingOutlined />,
  },
];

const Aside = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { logout } = useAuthContext();

  const getSelectedKeys = () => {
    if (location.pathname === "/") {
      return ["1"];
    } else if (location.pathname === "/white-list") {
      return ["2"];
    }
    return ["1"];
  };

  const onSignOutClick: MouseEventHandler<HTMLButtonElement> = () => {
    logout();
  };

  return (
    <aside className={styles.aside}>
      <img onClick={() => window.location.reload()} className={styles.logo} src={asideLogo} alt="Aside Logo" />
      <Menu
        mode="inline"
        className={styles.menu}
        inlineCollapsed
        selectedKeys={getSelectedKeys()}
        items={menuItems}
        onClick={(info) => {
          if (info.key === "1") {
            navigate("/");
          } else if (info.key === "2") {
            navigate("/white-list");
          }
        }}
      />
      <Tooltip title="Sortir" placement="right">
        <Button className={styles.signOutButton} size="small" icon={<LogoutOutlined />} onClick={onSignOutClick}/>
      </Tooltip>
      <Dropdown placement="topLeft" menu={{ items: helpItems }} trigger={["click"]}>
        <Tooltip title="Suport" placement="right">
          <Button size="small" icon={<QuestionOutlined />} />
        </Tooltip>
      </Dropdown>
    </aside>
  );
};
export default Aside;
